import React from "react";
import { Card, Typography, Divider } from "antd";
const { Title, Paragraph } = Typography;

export default function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <Card className="privacy-card" bordered>
        <Typography className="privacy-text">

          <Title level={2} className="privacy-title">
            Privacy Policy
          </Title>

          <Paragraph className="updated-text">
            <strong>Last Updated: 18 December 2025</strong>
          </Paragraph>

          <Paragraph>
            Welcome to <strong>Fusion Hub</strong>. Fusion Hub is a gym and fitness
            training–related platform. Your privacy is extremely important to us.
            This Privacy Policy explains how we collect, use, store, and protect
            your personal information when you use our website, mobile application,
            and related services.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            1. Information We Collect
          </Title>

          <Paragraph>
            <strong>1.1 Personal Information</strong><br />
            We may collect personal details such as name, email address, phone
            number, gender, date of birth, address, and emergency contact details
            when you register or use our services.
          </Paragraph>

          <Paragraph>
            <strong>1.2 Fitness & Health Information</strong><br />
            This may include body measurements, fitness goals, workout history,
            diet preferences, progress tracking data, and uploaded progress photos.
            This information helps us provide personalized fitness services.
          </Paragraph>

          <Paragraph>
            <strong>1.3 Payment Information</strong><br />
            We collect payment-related information such as transaction IDs and
            payment status. <strong>Fusion Hub does not store card or banking
            details</strong>. All payments are processed through secure third-party
            payment gateways.
          </Paragraph>

          <Paragraph>
            <strong>1.4 Automatically Collected Information</strong><br />
            We may automatically collect technical data such as IP address,
            browser type, device information, operating system, pages visited,
            and time spent on the platform for analytics and performance improvement.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            2. How We Use Your Information
          </Title>

          <Paragraph>
            We use your information to:
            <br />• Create and manage user accounts
            <br />• Provide gym training programs, workout plans, and diet guidance
            <br />• Track fitness progress and performance
            <br />• Process payments and subscriptions securely
            <br />• Improve platform functionality and user experience
            <br />• Provide customer support and communication
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            3. Sharing of Information
          </Title>

          <Paragraph>
            Fusion Hub <strong>does not sell</strong> your personal information.
            We may share limited data only with:
            <br />• Trainers or coaches for providing fitness services
            <br />• Trusted third-party service providers (payment gateways, analytics tools)
            <br />• Legal or regulatory authorities when required by law
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            4. Data Storage & Security
          </Title>

          <Paragraph>
            We implement appropriate technical and organizational security measures
            such as encryption, secure servers, and restricted access to protect
            your data. However, no digital platform can guarantee 100% security,
            and you use our services at your own risk.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            5. Cookies & Tracking Technologies
          </Title>

          <Paragraph>
            Fusion Hub uses cookies and similar tracking technologies to enhance
            user experience, analyze usage patterns, and improve performance.
            You can manage or disable cookies through your browser settings.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            6. Your Rights
          </Title>

          <Paragraph>
            You have the right to request access, correction, or deletion of your
            personal information. You may also withdraw consent for certain data
            processing activities, subject to legal and contractual obligations.
          </Paragraph>

          <Divider />

          <Title level={4} className="section-title">
            7. Changes to This Privacy Policy
          </Title>

          <Paragraph>
            Fusion Hub reserves the right to update or modify this Privacy Policy
            at any time. Any changes will be reflected on this page, and continued
            use of our services indicates acceptance of the updated policy.
          </Paragraph>

          <Divider />

          <Paragraph>
            If you have any questions or concerns regarding this Privacy Policy,
            please contact us at: <strong>support@fusionhub.com</strong>
          </Paragraph>

        </Typography>
      </Card>
    </div>
  );
}
